export const isPayPerAgent = (): boolean => {
  const userProductsString = localStorage.getItem('userProducts');
  if (!userProductsString || userProductsString === 'undefined') {
    return false;
  }

  const userProducts = JSON.parse(userProductsString) as IUserProduct[];
  const hasAgentSeat = userProducts.find((up) => up.agentSeat === 1);

  return typeof hasAgentSeat === 'undefined';
};

export interface IUserProduct {
  businessproductid: number;
  businessid: number;
  startdate: Date;
  enddate?: Date;
  productid: number;
  includedunits?: number;
  priceperunit?: number;
  units: number;
  status: string;
  userid: number;
  numberid?: number;
  agentSeat?: number;
}
